/**
 * Customer Case timeline kinds. Narrative, not an audit log.
 * Only classify persisted event labels — never fabricate events.
 */

export const TIMELINE_KIND_MEASUREMENT = 'MEASUREMENT';
export const TIMELINE_KIND_IMMUTABLE_RESULT = 'IMMUTABLE RESULT';
export const TIMELINE_KIND_ACTION = 'ACTION';
export const TIMELINE_KIND_MANAGEMENT_STATE = 'MANAGEMENT STATE';

export type CaseTimelineKind =
  | typeof TIMELINE_KIND_MEASUREMENT
  | typeof TIMELINE_KIND_IMMUTABLE_RESULT
  | typeof TIMELINE_KIND_ACTION
  | typeof TIMELINE_KIND_MANAGEMENT_STATE;

export function classifyCaseTimelineKind(label: string): CaseTimelineKind {
  const text = String(label || '').trim().toLowerCase();
  if (/control evaluation/.test(text)) return TIMELINE_KIND_IMMUTABLE_RESULT;
  if (/signed record|signed scan|revision/.test(text)) return TIMELINE_KIND_IMMUTABLE_RESULT;
  if (/scheduled run/.test(text)) return TIMELINE_KIND_MANAGEMENT_STATE;
  if (/safety scan|follow-up scan|follow up scan|measurement/.test(text)) return TIMELINE_KIND_MEASUREMENT;
  if (/control|corrective|barrier|action recorded|action completed/.test(text)) return TIMELINE_KIND_ACTION;
  return TIMELINE_KIND_MANAGEMENT_STATE;
}
